import fetch from 'auth/FetchInterceptor';
import { API_BASE_URL } from 'configs/AppConfig';

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {FetchListParams} params
 * @returns {Promise<FetchLOIListResponse>}
 */
export function requestLoiList(params) {
    /**
     * @NOTE This limit is hard code for now because we need to implement the sorting nad filterting only at front end.
     *  In future we may remove it when sorting and filterting is implemented on backend
     */
    return fetch.get(`${BASE_URL}/api/app/loi`, {
        params: { limit: 10000 }
    });
}


/**
 *
 * @param {LOI Data} loiData
 */
 export function requestCreateLoi(loiData) {
    return fetch.post(`${BASE_URL}/api/app/loi`, {
        ...loiData
    });
}

/**
 *
 * @param {LOI Data} loiData
 */
export function requestUpdateLoi(loiData) {
    const data = { ...loiData };
    delete data['_id'];
    return fetch.put(`${BASE_URL}/api/app/loi/${loiData._id}`, {
        ...data
    });
}